import { loadSelectSourceData } from "@crescentParts/Services/SelectSourceService";
import {ApiHandler, createHandlerChainRunner} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{ 
	apiRoute: string,
	serialNumber: string
}>;

export const DispatchSelectSource: HandlerType = async props => {
	(props.apiResult as any) = await loadSelectSourceData(props.parameter);
}

export const chain = [DispatchSelectSource];

const selectSourceHandler = createHandlerChainRunner(chain, "selectSourceHandler");

export default selectSourceHandler; 